export const NEW_FORMULA_TMP_ID = "tmp-formula";
